import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ExcelExporterFunction  {
    _originalTypeClassName = "zERP.BO.ExcelExporterFunction";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ExcelExporterFunction.translate = translateService;
}
this.Arguments = [];
this.Name = null;
this.Description = null;
this.ExcelExporterFunctionKey = null;
this._key = this.ExcelExporterFunctionKey = 0; 
}

static translate: TranslateService;
_key: any;
Name:any;
Description:any;
Arguments:any;
private _ExcelExporterFunctionKey:any;
get ExcelExporterFunctionKey(): any {
    return this._ExcelExporterFunctionKey;
  }
set ExcelExporterFunctionKey(value: any) {
    this._ExcelExporterFunctionKey = value;
    this._key = value;
  }
static setArguments = ($this, items) => {
                if (items == null) items = [];
                if ($this.Arguments == null) $this.Arguments = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Arguments.length > 0) {
                    Domain.ExcelExporterFunction.removeArguments($this, $this.Arguments[0]);
                }

                Domain.ExcelExporterFunction.addManyArguments($this, copyItems);
            }
static addManyArguments = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.ExcelExporterFunction.addArguments($this, items[i]);
                }
            }
static addArguments = ($this, item) => {
                if ($this.Arguments == null) $this.Arguments = [];
                if (item == null || $this.Arguments.indexOf(item) > -1) return;
                $this.Arguments.push(item);
}
static addRangeArguments = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.ExcelExporterFunction.addArguments($this, item));
            }
static removeArguments = ($this, item) => {
                if ($this == null || $this.Arguments == null || $this.Arguments.indexOf(item) === -1) return;
                var _index = $this.Arguments.indexOf(item);
                $this.Arguments.splice(_index, 1);
}
static clearArguments = ($this) => { $this.Arguments = null; }

static Fill(name: any,description: any,paramNames: any,paramTypes: any,paramDescriptions: any): any{let func = new Domain.ExcelExporterFunction();
func.Name = name;
func.Description = description;
for (let _ip = 0; _ip < (paramNames == null ? 0 : paramNames.length); _ip++) {let p = paramNames[_ip];let index = paramNames?.indexOf(p);let fInput = new Domain.ExcelExporterFunctionInput();fInput.Name = p;fInput.Description = paramDescriptions[index];fInput.Datatype = paramTypes[index];func?.Arguments?.add(fInput);}
return func;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.ExcelExporterFunctionKey == null || $this.ExcelExporterFunctionKey == 0;
            }


}